import { Component, OnInit, inject } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { DecimalPipe } from '@angular/common';
import { PageTitleService } from '../../core/services/page-title.service';
import { AuthStateService } from '../../core/services/auth-state.service';
import { TaxRateService } from '../../core/services/tax-rate.service';
import { FlashService } from '../../core/services/flash.service';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';

@Component({
    selector: 'app-tax-rate-list',
    imports: [FormsModule, DecimalPipe, FlashMessageComponent],
    template: `
<div class="animated fadeIn">
  @if (userPermission > 10) {
    <div class="alert alert-warning">このページへのアクセス権限がありません。</div>
  } @else {
    <div class="row sfapp-container">
      <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-list"></i> 一覧 <span>(全 {{ items.length }} 件)</span></span>
        </div>
      <div class="card-body">
        <!-- 旧版 taxRate.html:11-13 の card-body 先頭 <flash-message> 相当 -->
        <div class="row"><app-flash-message class="col-md-12"></app-flash-message></div>
        <form novalidate #taxForm="ngForm" (ngSubmit)="save(taxForm)">
          <div class="row align-items-end">
            <div class="col-md-4">
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label" for="new_tax">消費税率（％）</label>
                  <input id="new_tax" name="new_tax" type="number" step="1" min="1" max="100"
                    [(ngModel)]="newTaxRate" class="form-control" placeholder="消費税率（％）" required>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group row">
                <div class="col-md-12">
                  <button class="btn btn-blue text-white" type="submit" [disabled]="taxForm.invalid">
                    <i class="fa s-icon-plus"></i>&nbsp;追加
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
        <hr>
      </div>
      <div class="card-body">
        @if (searching) {
          <div class="text-center py-3"><span class="fa fa-spinner fa-spin fa-2x"></span></div>
        }
        @if (!searching && items.length === 0) {
          <span>該当するデータはありません</span>
        }
        @if (items.length > 0) {
          @if (totalPages > 1) {
          <ul class="pagination pull-right">
            @if (shouldShowPager) {
              <li class="page-item" [class.disabled]="showStart === 0">
                <a class="page-link" href="" aria-label="Previous" (click)="pagerClick(0, $event)">
                  <span aria-hidden="true">&laquo;</span>
                  <span class="sr-only">Previous</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="currentPage === 0">
                <a class="page-link" href="" aria-label="Previous" (click)="pagerClick(currentPage - 1, $event)">
                  <span aria-hidden="true">prev</span>
                  <span class="sr-only">Previous</span>
                </a>
              </li>
            }
            @for (pager of pagerArr(); track pager) {
              @if (pager >= showStart && pager <= showEnd) {
                <li class="page-item" [class.active]="pager === currentPage">
                  <a href="" class="pager-item page-link" (click)="pagerClick(pager, $event)">{{ pager + 1 }}</a>
                </li>
              }
            }
            @if (shouldShowPager) {
              <li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
                <a class="page-link" href="" aria-label="Next" (click)="pagerClick(currentPage + 1, $event)">
                  <span aria-hidden="true">next</span>
                  <span class="sr-only">Next</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="showEnd >= totalPages - 1">
                <a class="page-link" href="" aria-label="Next" (click)="pagerClick(totalPages - 1, $event)">
                  <span aria-hidden="true">&raquo;</span>
                  <span class="sr-only">Next</span>
                </a>
              </li>
            }
          </ul>
          }
          <div class="form-group row">
            <div class="col-md-6">
              <label>&nbsp;</label>
              <table class="table table-bordered table-sm table-hover table-ptb-0">
                <thead>
                  <tr>
                    <th width="25%">状態</th>
                    <th width="50%">消費税率（％）</th>
                    <th width="25%"></th>
                  </tr>
                </thead>
                <tbody>
                  @for (item of pagedItems; track item.id) {
                    <tr>
                      <td class="text-center">
                        @if (item.status === 0) {
                          <button class="btn text-green p-0 bg-inherit active" type="button" (click)="setStatus(item, 1)">
                            <i class="fa fa-3x fa-toggle-on"></i>
                          </button>
                        } @else {
                          <button class="btn text-secondary bg-inherit p-0 active" type="button" (click)="setStatus(item, 0)">
                            <i class="fa fa-3x fa-toggle-off"></i>
                          </button>
                        }
                      </td>
                      <td class="text-right">{{ (item.rate * 100) | number }}</td>
                      <td class="text-center">
                        @if (item.status === 0) {
                          <button class="mt-1 mb-1 btn btn-secondary btn-sm text-white" type="button" disabled title="削除">
                            <i class="fa s-icon-delete fa-fw"></i>
                          </button>
                        }
                        @if (item.status === 1) {
                          <button class="mt-1 mb-1 btn btn-danger btn-sm" type="button" title="削除"
                            (click)="confirmDelete(item)">
                            <i class="fa s-icon-delete fa-fw"></i>
                          </button>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
          @if (totalPages > 1) {
          <ul class="pagination pull-right">
            @if (shouldShowPager) {
              <li class="page-item" [class.disabled]="showStart === 0">
                <a class="page-link" href="" aria-label="Previous" (click)="pagerClick(0, $event)">
                  <span aria-hidden="true">&laquo;</span>
                  <span class="sr-only">Previous</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="currentPage === 0">
                <a class="page-link" href="" aria-label="Previous" (click)="pagerClick(currentPage - 1, $event)">
                  <span aria-hidden="true">prev</span>
                  <span class="sr-only">Previous</span>
                </a>
              </li>
            }
            @for (pager of pagerArr(); track pager) {
              @if (pager >= showStart && pager <= showEnd) {
                <li class="page-item" [class.active]="pager === currentPage">
                  <a href="" class="pager-item page-link" (click)="pagerClick(pager, $event)">{{ pager + 1 }}</a>
                </li>
              }
            }
            @if (shouldShowPager) {
              <li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
                <a class="page-link" href="" aria-label="Next" (click)="pagerClick(currentPage + 1, $event)">
                  <span aria-hidden="true">next</span>
                  <span class="sr-only">Next</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="showEnd >= totalPages - 1">
                <a class="page-link" href="" aria-label="Next" (click)="pagerClick(totalPages - 1, $event)">
                  <span aria-hidden="true">&raquo;</span>
                  <span class="sr-only">Next</span>
                </a>
              </li>
            }
          </ul>
          }
        }
      </div>
    </div>
      </div>
    </div>
  }
</div>
  `
})
export class TaxRateListComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private authState = inject(AuthStateService);
  private taxRateService = inject(TaxRateService);
  private flash = inject(FlashService);

  get userPermission(): number { return this.authState.currentUser?.role ?? 99; }

  items: any[] = [];
  newTaxRate: number | null = null;
  searching = true;
  readonly pageLimit = 100;
  readonly columnWidth = 11;
  currentPage = 0;
  showStart = 0;
  showEnd = this.columnWidth - 1;

  get totalPages(): number {
    return Math.ceil(this.items.length / this.pageLimit);
  }

  get shouldShowPager(): boolean {
    return this.totalPages > this.columnWidth;
  }

  get pagedItems(): any[] {
    const begin = this.currentPage * this.pageLimit;
    return this.items.slice(begin, begin + this.pageLimit);
  }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('マスター管理', 's-icon-master');
    await this.updateList();
  }

  async updateList(): Promise<void> {
    this.searching = true;
    try {
      this.items = await this.taxRateService.get('all') ?? [];
      this.pagerClick(0);
    } finally {
      this.searching = false;
    }
  }

  pagerArr(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i);
  }

  pagerClick(page: number, event?: Event): void {
    event?.preventDefault();
    const maxPage = Math.max(0, this.totalPages - 1);
    const num = Math.min(Math.max(Math.ceil(page), 0), maxPage);
    if (num + 1 <= Math.floor(this.columnWidth / 2)) {
      this.showStart = 0;
      this.showEnd = this.columnWidth - 1;
    } else if (num + 1 > this.totalPages - Math.floor(this.columnWidth / 2)) {
      this.showStart = this.totalPages - this.columnWidth;
      this.showEnd = this.totalPages;
    } else {
      this.showStart = num - Math.floor(this.columnWidth / 2);
      this.showEnd = num + Math.floor(this.columnWidth / 2);
    }
    this.currentPage = num;
  }

  async save(form?: NgForm): Promise<void> {
    if (form?.invalid || this.newTaxRate == null) return;
    const newRate = this.newTaxRate / 100;
    const exists = this.items.some(({ rate }) => Number(rate) === newRate);
    if (exists) {
      this.newTaxRate = null;
      return;
    }
    await this.taxRateService.upsert({ rate: newRate, status: 1 });
    this.newTaxRate = null;
    form?.resetForm();
    await this.updateList();
  }

  async setStatus(item: any, status: number): Promise<void> {
    await this.taxRateService.upsert({ id: item.id, status });
    await this.updateList();
  }

  async confirmDelete(item: any): Promise<void> {
    const result: any = await this.taxRateService.remove(item.id);
    if (result?.isProtected) {
      this.flash.create('danger', '選択されたデータは削除できません。');
    }
    await this.updateList();
  }
}
